import { NUDGES_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export interface INudgesCartMedicineProps {
  customer_id: string;
  pet_id?: string;
  cart_id?: string;
  food_items?: any;
  grooming_membership_list?: any;
  membership_list?: any;
  source_type:string
  clinic_id?: string;
}

AxiosCurlirize(axios, () => {});

export const useFoodOnNudgeActionInCartAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (nudgeBody: INudgesCartMedicineProps) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .post(`${NUDGES_APIS?.NUDGES_ADD_FOOD_MEDICINE_INCART?.baseURL}`, nudgeBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            
            if (res.data.status) {
              toastNotification(res.data.message);
              return { status: true };
            } else {
              //
            }
          })
          .catch((e: AxiosError) => {
            // captureError(e);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        captureError(e);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};